import * as React from 'react';
import {
  StyleSheet,
  View,
  PixelRatio,
  Pressable,
  Platform,
  Modal,
} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import ScreenContext from '../../ScreenContext';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';

import FirebaseAnalytic from '../../../nativeModules/FirebaseAnalytic';
import Settings from 'src/Settings';
import BottomSheet from '@gorhom/bottom-sheet';
import RedeemTab from 'src/components/elements/rewards/RedeemTab';
import Styles from 'src/components/Styles';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../i18n/HOC/withGlobalize';

export type RedeemRewardScreenProps = WithGlobalizeProps & {
  productName: string;
  imageUrl?: string;
  rewardProductId?: string;
  productId?: string;
  point?: number;
  upc?: string[];
};
enum BottomSheetState {
  NOT_READY = 'NOT_READY',
  FULLY_OPEN = 'FULLY_OPEN',
  FULLY_CLOSED = 'FULLY_CLOSED',
}

type RedeemRewardScreenState = {
  modalVisible: boolean;
};

class RedeemRewardScreen extends React.Component<
  RedeemRewardScreenProps,
  RedeemRewardScreenState
> {
  static contextType = ScreenContext;
  declare context: React.ContextType<typeof ScreenContext>;
  bottomSheetRef: React.RefObject<BottomSheet> = React.createRef();
  declare bottomSheetCurrentState: BottomSheetState;
  declare bottomSheetCustomStates: Record<number, BottomSheetState>;
  constructor(props: RedeemRewardScreenProps) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.bottomSheetCustomStates = {
      [-1]: BottomSheetState.FULLY_CLOSED,
      0: BottomSheetState.FULLY_OPEN,
      999: BottomSheetState.NOT_READY,
    };
    this.state = {
      modalVisible: Platform.OS === 'web',
    };
  }

  componentDidMount() {
    FirebaseAnalytic.trackEvent('componentDidMount', 'RedeemRewardScreen', {
      ...this.props,
    });
    if (this.bottomSheetRef.current) {
      this.bottomSheetRef.current.close();
    }
  }

  onClose() {
    if (Platform.OS === 'web') {
      this.setState({modalVisible: false}, () => {
        this.trackOnCloseEvent();
        this.handleNavigation();
      });
    } else {
      if (!this.bottomSheetRef.current) {
        return;
      }
      this.trackOnCloseEvent();
      this.handleNavigation();
    }
  }

  handleNavigation() {
    if (Settings.isNewUI()) {
      this.handleNewUINavigation();
    } else {
      NavActions.navigate(AppRoutes.Main);
    }
  }

  handleNewUINavigation() {
    if (NavActions.getLastRoute() === AppRoutes.ScanAccount) {
      NavActions.popToRoute(AppRoutes.Scan);
    } else if (NavActions.getLastRoute() === AppRoutes.Balances) {
      NavActions.popToRoute(AppRoutes.Balances);
    } else {
      NavActions.pop();
    }
  }

  handleSheetChange = (index: number) => {
    this.bottomSheetCurrentState = this.bottomSheetCustomStates[index];
    if (index === -1) {
      this.onClose();
    }
  };

  trackOnCloseEvent() {
    FirebaseAnalytic.trackEvent('onClose', 'RedeemRewardScreen', {
      ...this.props,
      navigate: AppRoutes.Main,
    });
  }

  renderModal() {
    return (
      <Modal
        animationType="fade"
        transparent={true}
        visible={this.state.modalVisible}
        onRequestClose={this.onClose}
      >
        <View style={styles.modalBackdrop}>
          <View style={styles.modalContainer}>{this.renderInner()}</View>
        </View>
      </Modal>
    );
  }

  renderBottomSheet() {
    return (
      <BottomSheet
        ref={this.bottomSheetRef}
        snapPoints={['80%']}
        enableHandlePanningGesture={true}
        enablePanDownToClose={true}
        onChange={this.handleSheetChange}
        style={styles.bottomSheet}
        enableContentPanningGesture={true}
        index={0}
        enableDynamicSizing
      >
        {this.renderInner()}
      </BottomSheet>
    );
  }

  render() {
    return (
      <View style={styles.container} testID="pressable-element">
        <Pressable
          nativeId="Btn-pressable-element"
          style={styles.touchable}
          onPress={() => {
            if (this.bottomSheetCurrentState === undefined) {
              NavActions.pop();
            } else if (this.bottomSheetRef.current) {
              this.bottomSheetRef.current.forceClose();
            }
          }}
        />
        {Platform.OS === 'web' ? this.renderModal() : this.renderBottomSheet()}
      </View>
    );
  }

  renderInner() {
    return (
      <RedeemTab
        productName={this.props.productName}
        imageUrl={this.props.imageUrl}
        point={this.props.point}
        upc={this.props.upc}
        cancel={this.onClose}
        rewardProductId={this.props.rewardProductId}
        productId={this.props.productId}
        hideOnly={() => this.setState({modalVisible: false})}
      />
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  contentContainer: {
    padding: 16,
  },
  bottomSheet: {
    borderRadius: 32, // Set the radius for rounded corners
    overflow: 'hidden', // Ensures child elements are clipped to the rounded corners
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  modalContainer: {
    width: '100%',
    maxWidth: 600,
    backgroundColor: Styles.Colors.PayNew.white01,
    borderRadius: Styles.Spacing.m3 + Styles.Spacing.m2,
    overflow: 'hidden',
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  touchable: {
    width: '100%',
    height: '60%',
    backgroundColor: 'transparent',
  },
});
export default withForwardedNavigationParams()(
  withGlobalize(RedeemRewardScreen),
);
